export const DIRECTIVE = {
  inserted: function (el) {
    el.focus()
  }
}

export default {
  install (Vue) {
    Vue.directive('focus', DIRECTIVE)
  }
}
